import React, { useState } from "react";
import "./airdrops.css";

const ConnectWalletModal = ({ isOpen, onClose }) => {
  const [activeTab, setActiveTab] = useState("agce");
  const [walletAddress, setWalletAddress] = useState("");

  if (!isOpen) return null;

  return (
    <div className="wallet-modal-overlay" onClick={onClose}>
      <div
        className="wallet-modal-card"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Top Header */}
        <div className="wallet-modal-header">
          <div className="wallet-modal-title-wrap">
            <h3 className="wallet-modal-title">Connect Your Wallet</h3>
            <p className="wallet-modal-subtitle">
              Start your crypto journey with AGCX
            </p>
          </div>

          {/* Floating Illustration */}
          <img
            src="/images/airdrop-img/wallet_vector.png"
            alt="Wallet Illustration"
            className="wallet-header-graphic"
          />

          {/* Close Button */}
          <button
            type="button"
            className="wallet-modal-close-btn"
            onClick={onClose}
            aria-label="Close modal"
          >
            <i className="ri-close-line"></i>
          </button>
        </div>

        {/* Tab Navigation */}
        <div className="wallet-modal-tabs-wrap">
          <div className="wallet-modal-tabs">
            <button
              type="button"
              className={`wallet-tab-btn ${activeTab === "agce" ? "active" : ""}`}
              onClick={() => setActiveTab("agce")}
            >
              AGCX Wallet
            </button>
            <button
              type="button"
              className={`wallet-tab-btn ${activeTab === "other" ? "active" : ""}`}
              onClick={() => setActiveTab("other")}
            >
              Other Wallet
            </button>
            <button
              type="button"
              className={`wallet-tab-btn ${activeTab === "watch" ? "active" : ""}`}
              onClick={() => setActiveTab("watch")}
            >
              Watch-Only Wallet
            </button>
          </div>
        </div>

        {/* Modal Body Content */}
        <div className="wallet-modal-body">
          {/* --- TAB 1: AGCX Wallet --- */}
          {activeTab === "agce" && (
            <div className="agce-wallet-content">
              {/* Box 1: AGCX App */}
              <div className="wallet-option-box">
                <div className="wallet-option-left">
                  <h4 className="option-title">AGCX App</h4>
                  <p className="option-desc">
                    Scan the QR code to connect your wallet
                  </p>
                  <div className="option-status-link">
                    <span className="status-dot"></span>
                    <span className="status-text">Not installed yet? </span>
                    <a href="#download" className="gold-link" onClick={(e) => e.preventDefault()}>
                      Download Now &gt;
                    </a>
                  </div>
                </div>
                <div className="wallet-qr-wrap">
                  <img
                    src="/images/airdrop-img/scan_airdrop.png"
                    alt="Scan QR code"
                    className="qr-img"
                  />
                </div>
              </div>

              {/* OR Divider */}
              <div className="wallet-divider">
                <span>OR</span>
              </div>

              {/* Box 2: AGCX Extension */}
              <div className="wallet-option-box flex-row-center">
                <div className="wallet-option-left">
                  <h4 className="option-title">AGCX Wallet Chrome Extension</h4>
                  <p className="option-desc">
                    Connect using AGCX Wallet Extension
                  </p>
                </div>
                <button type="button" className="gold-action-btn">
                  + Add Extension
                </button>
              </div>
            </div>
          )}

          {/* --- TAB 2: Other Wallet --- */}
          {activeTab === "other" && (
            <div className="other-wallet-content">
              <div className="other-wallet-section-title">
                <span>Choose Your Wallet</span>
              </div>
              <div className="other-wallet-grid">
                {/* Card 1: MetaMask */}
                <div className="other-wallet-card">
                  <div className="other-wallet-icon-wrap">
                    <img
                      src="/images/airdrop-img/meta_mask.png"
                      alt="MetaMask"
                    />
                  </div>
                  <h5 className="other-wallet-name">MetaMask</h5>
                  <button type="button" className="outline-connect-btn">
                    Connect
                  </button>
                </div>

                {/* Card 2: WalletConnect */}
                <div className="other-wallet-card">
                  <div className="other-wallet-icon-wrap">
                    <img
                      src="/images/airdrop-img/walletconnect.png"
                      alt="WalletConnect"
                    />
                  </div>
                  <h5 className="other-wallet-name">WalletConnect</h5>
                  <button type="button" className="outline-connect-btn">
                    Connect
                  </button>
                </div>

                {/* Card 3: Solana Wallet */}
                <div className="other-wallet-card">
                  <div className="other-wallet-icon-wrap">
                    <img
                      src="/images/airdrop-img/solana_wallet.png"
                      alt="Solana Wallet"
                    />
                  </div>
                  <h5 className="other-wallet-name">Solana Wallet</h5>
                  <button type="button" className="outline-connect-btn">
                    Connect
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* --- TAB 3: Watch-Only Wallet --- */}
          {activeTab === "watch" && (
            <div className="watch-wallet-content">
              {/* Top Banner */}
              <div className="watch-info-banner">
                <div className="watch-info-icon">
                  <i className="ri-wallet-3-line"></i>
                </div>
                <div className="watch-info-text">
                  <h5 className="watch-info-title">Watch-Only Wallet</h5>
                  <p className="watch-info-desc">
                    Track balances, view transactions, and monitor portfolio
                    without connecting or signing any transactions.
                  </p>
                </div>
              </div>

              {/* Section 1: Connect by Address */}
              <div className="watch-section">
                <h4 className="watch-section-title">Connect a Wallet by Address</h4>
                <div className="watch-input-group">
                  <input
                    type="text"
                    placeholder="Enter wallet address (0x...0c...etc.)"
                    value={walletAddress}
                    onChange={(e) => setWalletAddress(e.target.value)}
                    className="watch-input"
                  />
                  <button type="button" className="watch-connect-btn">
                    Connect
                  </button>
                </div>
              </div>

              {/* OR Divider */}
              <div className="wallet-divider">
                <span>OR</span>
              </div>

              {/* Section 2: Scan QR Code */}
              <div className="watch-scan-section">
                <div className="watch-scan-left">
                  <h4 className="watch-section-title">Scan Wallet QR Code</h4>
                  <p className="watch-section-desc">
                    Scan the QR code of the wallet you want to monitor.
                  </p>
                </div>
                <button type="button" className="gold-action-btn">
                  + Scan QR
                </button>
              </div>
            </div>
          )}
        </div>

        {/* Security / Terms Footer */}
        <div className="wallet-modal-footer">
          <div className="footer-terms-left">
            <i className="ri-shield-check-line terms-shield-icon"></i>
            <p className="terms-text">
              By connecting to AGCX wallet, you agree to AGCX's{" "}
              <a href="#terms" className="gold-terms-link" onClick={(e) => e.preventDefault()}>
                Terms of Service
              </a>{" "}
              and{" "}
              <a href="#privacy" className="gold-terms-link" onClick={(e) => e.preventDefault()}>
                Privacy Policy
              </a>
              .
            </p>
          </div>
          <img
            src="/images/airdrop-img/wallet_security.png"
            alt="Security Lock"
            className="footer-security-graphic"
          />
        </div>
      </div>
    </div>
  );
};

export default ConnectWalletModal;
